/**
 * GENERATED FILE — do not edit by hand.
 * Regenerate with: node gen-strings.mjs
 *
 * Source of truth: sites/copy/catalog-try.json (role:"ui" entries only, 156 keys).
 * Flat, dotted, quoted keys — grep the key to find every call site.
 */
export const S = {
  "account.authenticatorKey": "Klíč pro autentikátor: {key}",
  "account.backendNote": "Samotné přihlášení běží na serveru, v ukázce ho nespustíte. Kód nahoře je skutečný.",
  "account.codeCountdown": "{seconds}",
  "account.codeFormat": "{code3a} {code3b}",
  "account.codeLoading": "••• •••",
  "account.method.google": "Přihlášení přes Google",
  "account.method.password": "Heslo",
  "account.method.twoFactor": "Dvoufázové ověření",
  "account.title": "Účet a přihlášení",
  "account.totpExplanation": "Kód používá standard TOTP (RFC 6238) a ukázkový klíč. Zadejte klíč do autentikátoru; kódy se budou shodovat. Ve Veldonu chrání přihlášení i publikování.",
  "account.twoFactorCode": "Dvoufázový kód",
  "action.back": "Zpět",
  "action.done": "Hotovo",
  "action.remove": "Odebrat",
  "assistant.addTerracePhoto.adding": "Přidávám fotku terasy",
  "assistant.addTerracePhoto.opening": "Otevírám galerii…",
  "assistant.changedSite": "Asistent upravil web",
  "assistant.completed": "Hotovo. Změna čeká v konceptu.",
  "assistant.demoLabel": "Ukázka · připravené pokyny",
  "assistant.intent.addTerracePhoto": "Přidejte fotku terasy do galerie",
  "assistant.intent.raiseVealPrice": "Zdražte telecí žebro o 40 Kč",
  "assistant.intent.rewriteHero": "Přepište úvodní nadpis",
  "assistant.intent.shortenFriday": "Zkraťte páteční provoz do 23:00",
  "assistant.intent.undo": "Vraťte poslední změnu",
  "assistant.intro": "Asistent používá stejné nástroje jako vy. Jeho úpravy vrátíte tlačítkem Zpět.",
  "assistant.raiseVealPrice.changing": "Zvyšuji cenu telecího žebra o 40 Kč",
  "assistant.raiseVealPrice.opening": "Otevírám menu → Z ohniště…",
  "assistant.rewriteHero.changing": "Měním nadpis na „Poctivá kuchyně nad Brnem“",
  "assistant.rewriteHero.opening": "Otevírám úvodní sekci…",
  "assistant.shortenFriday.changing": "Nastavuji páteční otevírací dobu: 12:00 až 23:00",
  "assistant.shortenFriday.opening": "Otevírám otevírací dobu…",
  "assistant.undo.running": "Vracím poslední úpravu…",
  "assistant.unsupported": "Připravený pokyn se nepodařilo spustit.",
  "assistant.userLabel": "vy",
  "browserState.draft": "koncept",
  "browserState.live": "naživo · č. {n}",
  "browserState.unsaved": "nepublikováno",
  "checkout.cardNumberPlaceholder": "0000 0000 0000 0000",
  "checkout.cardPayment": "Platba kartou",
  "checkout.cvcPlaceholder": "CVC",
  "checkout.doneTitle": "Hotovo (ukázka)",
  "checkout.expiryPlaceholder": "MM/RR",
  "checkout.featureStatus": "Objednávky, poukazy a platby jsou součást Veldonu.",
  "checkout.giftValue": "Hodnota poukazu",
  "checkout.orderAccepted": "Objednávka přijata. Nic se nestrhlo.",
  "checkout.pay": "Zaplatit {amount} Kč",
  "checkout.processing": "Zpracovávám…",
  "checkout.productNotFound": "Produkt nenalezen",
  "checkout.productionExplanation": "Platby a objednávky jsou v ukázce simulované. V produkci je zajišťuje engine se Stripe účtem provozovatele.",
  "checkout.safetyNote": "Toto je ukázka. Karta se nikam neposílá a nic se nestrhne.",
  "checkout.testCardNumber": "4242 4242 4242 4242",
  "checkout.testCvc": "123",
  "checkout.testExpiry": "04/28",
  "checkout.testMode": "Testovací režim",
  "checkout.understand": "Rozumím",
  "contact.field.consent": "Souhlas",
  "contact.field.heading": "Nadpis",
  "contact.field.intro": "Úvodní text",
  "contact.field.submitLabel": "Text tlačítka",
  "contact.field.successMessage": "Zpráva po odeslání",
  "currency.formattedKoruna": "{amount} Kč",
  "demo.badge": "Ukázka",
  "editions.emptyHelp": "Zatím žádná verze. Upravte web a klikněte na Publikovat.",
  "editions.help": "Publikované verze zůstávají uložené. Vyberte, ke které se chcete vrátit.",
  "editions.number": "č. {n}",
  "editions.restore": "Vrátit",
  "editions.restored": "Web je zpět ve verzi č. {n}.",
  "editions.state.edition": "verze",
  "editions.state.live": "naživo",
  "editions.time": "{time}",
  "events.add": "Přidat akci",
  "events.addOptionalPhoto": "Přidat fotku (nepovinné)",
  "events.changePhoto": "Změnit fotku",
  "events.ctaLabelPlaceholder": "Text odkazu (např. Vstupenky)",
  "events.ctaUrlPlaceholder": "Odkaz na FB nebo web (nepovinné)",
  "events.help": "Datum a název jsou povinné, fotka a odkaz (třeba na Facebook) nepovinné.",
  "events.imagePickerTitle": "Vyberte fotku akce",
  "events.removeEvent": "Odebrat akci",
  "events.removePhoto": "Odebrat fotku",
  "events.titlePlaceholder": "Název akce",
  "events.validation.linkPair": "Vyplňte text i odkaz, nebo nechte obojí prázdné",
  "events.validation.newEvent": "Zadejte název i datum",
  "events.validation.requiredExisting": "Název i datum musí být vyplněné",
  "field.placeholder.name": "Název",
  "field.placeholder.optionalDescription": "Popis (nepovinné)",
  "field.placeholder.price": "Cena",
  "field.validation.required": "Toto pole nesmí být prázdné",
  "flash.saved": "Uloženo",
  "gallery.libraryEmpty": "Všechny fotky z knihovny jsou použité.",
  "gallery.libraryHeading": "Přidat z knihovny",
  "gallery.libraryHeadingFull": "Přidat z knihovny (plno)",
  "gallery.moveDown": "Dolů",
  "gallery.moveUp": "Nahoru",
  "handoff.heading": "Tohle umí i váš web",
  "handoff.howItWorks": "Jak to funguje",
  "handoff.startFree": "Začít zdarma",
  "handoff.text": "Napojte vlastní web a nechte klienta upravovat obsah bezpečně. První produkční web je zdarma.",
  "hours.closed": "Zavřeno",
  "hours.help": "Upravte časy pro jednotlivé dny.",
  "hours.saveFailed": "Otevírací dobu se nepodařilo uložit",
  "hours.saved": "Otevírací doba uložena",
  "hours.validation.invalidTime": "Zadejte platný čas ve formátu HH:MM",
  "hours.weekday.fri": "Pá",
  "hours.weekday.mon": "Po",
  "hours.weekday.sat": "So",
  "hours.weekday.sun": "Ne",
  "hours.weekday.thu": "Čt",
  "hours.weekday.tue": "Út",
  "hours.weekday.wed": "St",
  "imagePicker.changeFailed": "Fotku se nepodařilo vyměnit",
  "imagePicker.changed": "Fotka vyměněna",
  "imagePicker.title": "Vyberte fotku",
  "inline.imageTooltip": "Kliknutím vyměníte fotku",
  "menu.addItem": "Přidat položku",
  "menu.validation.nameAndPrice": "Název i cena musí být vyplněné",
  "panel.assistantTitle": "AI asistent",
  "panel.contactTitle": "Kontaktní formulář",
  "panel.hoursTitle": "Otevírací doba",
  "products.addHeading": "Přidat produkt",
  "products.addToShop": "Přidat do obchodu",
  "products.available": "V obchodě",
  "products.giftPriceTooltip": "Cenu poukazu volí zákazník",
  "products.help": "Přidejte produkt, upravte cenu nebo ho skryjte z obchodu.",
  "products.namePlaceholder": "Název produktu",
  "products.validation.emptyName": "Název nesmí být prázdný",
  "products.validation.newProduct": "Zadejte název i cenu",
  "publish.editionOnline": "Verze č. {n} je naživo.",
  "publish.explanation": "V ostrém provozu web publikuje verze, které váš frontend načítá. Hosting zůstává váš.",
  "publish.hashAndDomain": "{hash}",
  "publish.noChanges": "Od poslední verze se nic nezměnilo.",
  "publish.rollbackAction": "Vrátit web na předchozí verzi",
  "publish.rollbackDone": "Hotovo. Web se vrátil na verzi č. {n}.",
  "publish.rollbackExplanation": "Každá publikace je samostatná verze. Kdykoli se můžete vrátit.",
  "publish.showEditions": "Zobrazit verze",
  "publish.title": "Web je publikovaný",
  "rail.editions": "Verze",
  "rail.events": "Akce",
  "rail.gallery": "Galerie",
  "rail.menu": "Menu",
  "rail.products": "Produkty",
  "reset.confirm": "Opravdu vrátit web do původního stavu? Vaše úpravy se smažou.",
  "reset.done": "Web je zpět v původním stavu",
  "save.failed": "Úpravu se nepodařilo uložit",
  "sectionChip.contact": "Upravit formulář",
  "sectionChip.events": "Upravit akce",
  "sectionChip.gallery": "Upravit galerii",
  "sectionChip.hours": "Upravit otevírací dobu",
  "sectionChip.menu": "Upravit menu",
  "sectionChip.products": "Upravit produkty",
  "share.copied": "Odkaz na vaši verzi zkopírován do schránky",
  "share.copyManually": "Odkaz je v adresním řádku, zkopírujte jej ručně",
  "share.exportFallback": "Verze je na odkaz moc velká, stáhla se jako soubor.",
  "share.exportFilename": "hreben-veldon.json",
  "shop.buy": "Koupit",
  "toast.invalidShareLink": "Neplatný odkaz - otevřel se výchozí web.",
  "toast.sharedVersionLoaded": "Verze načtena ze sdíleného odkazu",
} as const;
